import { styled } from "styled-components";

export const StyledCamelBottom = styled.header`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    gap: 1.6rem;
    margin-bottom: 3.2rem;
    width: 100%;
`;
